// import components
import type { DrawerProps } from '@mui/material';
import { styled, Box, Drawer } from '@mui/material';

export const StyledDrawerTitleBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: `1px solid ${theme.palette.divider}`
}));

export const StyledDrawer = styled(Drawer)<DrawerProps>(() => ({
  height: '100%'
}));

export const StyledDrawerContent = styled(Box)(() => ({
  height: '100%'
}));
